import React, { ReactElement, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDebounce } from "react-use";
import { generateSpecialPassword } from "helpers/generic";

import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";

import IconSelector from "components/shared/images/IconSelector";

import { ILocations } from "types/api/serversApiInterface";

const HPassword = ({
 password,
 setData
}: {
 password: string;
 setData: (section: string, value: string | number | boolean | ILocations) => void;
}): ReactElement => {
 const [showPassword, setShowPassword] = useState<string>("password");
 const [passwordValue, setPasswordValue] = useState<string>(password);

 const handleGeneratePassword = async () => {
  setPasswordValue(generateSpecialPassword(10));
 };

 useDebounce(
  () => {
   if (passwordValue !== password) setData("password", passwordValue);
  },
  1000,
  [passwordValue]
 );

 return (
  <Stack direction="row" spacing={2} alignItems="center">
   <TextField
    fullWidth={true}
    InputLabelProps={{ shrink: true }}
    sx={{ my: 2 }}
    value={passwordValue}
    autoFocus
    onChange={({ currentTarget }) => setPasswordValue(currentTarget.value)}
    type={showPassword}
    autoComplete="new-password"
    error={passwordValue === "" || passwordValue.length < 8}
    InputProps={{
     endAdornment: (
      <InputAdornment position="end">
       <IconButton
        aria-label="toggle password visibility"
        onClick={() => {
         setShowPassword(showPassword === "text" ? "password" : "text");
        }}
        edge="end">
        {showPassword ? (
         <IconSelector icon="VisibilityOffIcon" />
        ) : (
         <IconSelector icon="VisibilityIcon" />
        )}
       </IconButton>
      </InputAdornment>
     )
    }}
   />
   <Button onClick={handleGeneratePassword} sx={{ width: "40%" }}>
    <FormattedMessage id="app.generatePassword" />
   </Button>
  </Stack>
 );
};

export default HPassword;
